const margin = 8;
const isAboveOfViewport = (element, position) => {
  position.top <= margin - parseInt(window.getComputedStyle(element).marginTop, 10); // eslint-disable-line
};
const isBelowOfViewport = (element, position) => {
  position.top + element.offsetHeight + margin >= window.innerHeight - parseInt(window.getComputedStyle(element).marginTop, 10); // eslint-disable-line
};
const isOnTheLeftOfViewport = (element, position) => {
  position.left <= margin - parseInt(window.getComputedStyle(element).marginLeft, 10); // eslint-disable-line
};
const isOnTheRightOfViewport = (element, position) => {
  position.left + element.offsetWidth + margin >= window.innerWidth - parseInt(window.getComputedStyle(element).marginLeft, 10); // eslint-disable-line
};
const getInViewPosition = (element, position) => {
  const computedStyle = window.getComputedStyle(element); // eslint-disable-line
  if (isAboveOfViewport(element, position)) {
    position.top = margin - parseInt(computedStyle.marginTop, 10);
  }
  if (isOnTheLeftOfViewport(element, position)) {
    position.left = margin - parseInt(computedStyle.marginLeft, 10);
  }
  if (isOnTheRightOfViewport(element, position)) {
    position.left = window.innerWidth - margin - element.offsetWidth - parseInt(computedStyle.marginLeft, 10); // eslint-disable-line
  }
  if (isBelowOfViewport(element, position)) {
    position.top = window.innerHeight - margin - element.offsetHeight - parseInt(computedStyle.marginTop, 10); // eslint-disable-line
  }
  return position;
};
export default getInViewPosition;



// WEBPACK FOOTER //
// ./src/shared-components/datepicker/getInViewPosition.js